import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { footerCopy } from '../data/translations/contact';
export function Footer() {
  const {
    language
  } = useLanguage();
  const copy = footerCopy[language];
  return <footer className="bg-navy py-12 relative" data-id="element-46" data-mp="32p5qer82vgu2">
      <div aria-hidden="true" className="fade-to-footer absolute bottom-full left-0 right-0 h-[200px] pointer-events-none" data-id="element-47" data-mp="36pfv80k4w17c"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10 text-center space-y-2" data-id="element-48" data-mp="3ufjwi19unov6">
        <p className="text-cream-50/85 text-sm" data-id="element-49" data-mp="37fun6gwqy3r">{copy.copyright}</p>
        <p className="text-cream-50/85 text-sm" data-id="element-50" data-mp="3levih6kghoia">
          {copy.kvk} · {copy.vat}
        </p>
        <p className="text-sm" data-id="element-51" data-mp="3qcxbokblj47h">
          <a href={`mailto:${copy.email}`} className="text-cream-50 hover:text-gold-300 transition-colors" data-id="element-52" data-mp="3qc3zh3tvbmhy">
            {copy.email}
          </a>
        </p>
        <p className="text-sm" data-id="element-53" data-mp="2ezbf4e3eq0bx">
          <a href="/privacy" className="text-cream-50 hover:text-gold-300 underline underline-offset-2 transition-colors" data-id="element-54" data-mp="2ew6z8jgkxg5f">
            {copy.privacy}
          </a>
        </p>
      </div>
    </footer>;
}